import { render, staticRenderFns } from "./ShopMobileBlock.vue?vue&type=template&id=52f92b07&scoped=true"
import script from "./ShopMobileBlock.vue?vue&type=script&lang=js"
export * from "./ShopMobileBlock.vue?vue&type=script&lang=js"
import style0 from "./ShopMobileBlock.vue?vue&type=style&index=0&id=52f92b07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f92b07",
  null
  
)

export default component.exports